import { render, staticRenderFns } from "./ranking.vue?vue&type=template&id=19074eea&"
import script from "./ranking.vue?vue&type=script&lang=ts&"
export * from "./ranking.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19074eea')) {
      api.createRecord('19074eea', component.options)
    } else {
      api.reload('19074eea', component.options)
    }
    module.hot.accept("./ranking.vue?vue&type=template&id=19074eea&", function () {
      api.rerender('19074eea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/ranking/ranking.vue"
export default component.exports